const x = (a, e, s, o, c, n, i) => {
  const r = [];
  for (let t = 0; t < a; t++)
    r.push({
      id: t + 1,
      mandatoryExtras: [],
      optionalExtras: [],
      cityTaxes: "",
      ...e,
      ...s,
      arrivalDate: o,
      departureDate: c,
      totalAdults: n,
      totalChildren: i
    });
  return r;
};
export {
  x as createNewCartItems
};
